module.exports = __webpack_public_path__ + "img/estornar.bff9fbb2.svg";